import React, { useContext } from 'react';
import classes from './ResourcePageHeader.module.scss';
import Button from '@/components/Button/Button';
import t from '@/utils/Language/UI-translations';
import ReferButton from '@/components/Referrals/ReferButton/ReferButton';
import MoreActionsDropdown from '@/components/MoreActionsDropdown/MoreActionsDropdown';
import SaveButton from '@/components/SaveButton/SaveButton';
import { modalContext } from '@/context/modal.context';
import { AccountContext } from '@/context/account.context';
import { viewportContext } from '@/context/viewport.context';
import { resourceHelpers } from '@/utils/helpers';
import useMarkUnavailable from '@/hooks/useMarkUnavailable';
import useMixpanel from '@/hooks/useMixpanel';

// Manages the Save/Refer/Collections/Mark-unavailable/3-dot-menu actions.
// Save/Refer always shows; Collections folds into the 3-dot menu on small screens;
// Mark unavailable shows only when the member is a pro affiliated with the
// resource's organization.
const ResourcePageHeader = ({ resource, isPro }) => {
  const modal = useContext(modalContext);
  const account = useContext(AccountContext);
  const { isXs } = useContext(viewportContext);
  const { openMarkUnavailableModal } = useMarkUnavailable();
  const { track } = useMixpanel();

  const isOrganization = resource?.resource_type === 'Organization';
  const resourceOrgId = isOrganization ? resource?.id : resource?.organization?.id;
  const isAffiliatedWithResourceOrg = isPro && !!account?.data?.affiliation && account?.data?.affiliation?.fetchable_id == resourceOrgId;
  const isAvailable = isOrganization ? !resource?.is_closed : !resourceHelpers.isCurrentlyUnavailable(resource);

  const resourceObj = {
    resource_type: resource?.resource_type,
    id: resource?.id,
    slug: resource?.slug
  };

  const openAddToCollectionModal = () => {
    if (account?.state?.isLoggedIn) {
      modal.enqueueModal({
        name: 'AddToCollectionModal',
        resource: resource
      });
    } else {
      track('Signup prompted', { source: 'collections button', resource_id: resource.id, resource_type: resource.resource_type });
      modal.enqueueModal({
        name: 'SignupModal'
      });
    }
  };

  return (
    <div className={classes.headerRight}>
      {isPro ? (
        <ReferButton buttonType="link" resource={resource} source={isOrganization ? 'organization' : 'opportunity'} />
      ) : (
        <SaveButton buttonType="link" resource={resourceObj} />
      )}

      {!isXs && <Button type="link" icon={{ style: 'fas', font: 'book' }} text={t('Collections')} onButtonClick={openAddToCollectionModal} />}

      {isAffiliatedWithResourceOrg && (
        <Button
          type="link"
          icon={{ style: 'fas', font: isAvailable ? 'circle-xmark' : 'circle-plus' }}
          text={isAvailable ? t('Mark unavailable') : t('Mark available')}
          onButtonClick={() => openMarkUnavailableModal(resource)}
        />
      )}

      <MoreActionsDropdown resource={resource} hideUnavailableOption={isAffiliatedWithResourceOrg} />
    </div>
  );
};

export default ResourcePageHeader;
